import React, { useState } from 'react'
import { Typography, Box, Button, Hidden } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { routes } from 'Routes'

import {
  BaseConfirmationDialog,
  LoadingFeedback,
  UpgradeModal,
} from 'components'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

import clock from 'images/clock.png'
import useStyles from './styles'

const DisplayStaticUseLimitationNotice = ({
  textPrimary = 'Período Teste',
  textSecondary = 'dias restantes',
  buttonText = 'REALIZAR CONTRATAÇÃO',
  isSupplier,
}) => {
  const [rdMarketing, setRdMarketing] = useState(false)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()
  const { company } = useAuth()
  const classes = useStyles()

  const endDate = helpers.formatters.calcDays(company?.demoPartner?.endDate)

  const handleOpen = () => setOpen(true)
  const handleNotify = async () => {
    setLoading(true)
    try {
      const response = await service.dponet.companyFreeTrials.notify_hire()
      const success = response?.data?.success

      if (success) {
        setRdMarketing(true)
      } else {
        snackbar.open({
          message: response?.data?.message,
          variant: 'error',
        })
      }
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleRedirect = () => {
    const token =
      company?.preRegistrationToken || company?.preRegistration?.token

    if (isSupplier) return handleOpen()
    if (token) {
      history.push({
        pathname: routes.subscription.default,
        search: `segment=${company?.segment?.name}&token=${token}`,
      })
    } else {
      handleNotify()
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <UpgradeModal
        open={open}
        onClose={() => history.push(routes.home)}
        setOpen={setOpen}
      />
      <Box className={classes.alert}>
        <Hidden smDown>
          <Box display="flex" alignItems="center">
            <img src={clock} alt="Logo" width={30} />
            <Box ml={1}>
              <Typography>{textPrimary}</Typography>
            </Box>
          </Box>
        </Hidden>
        <Box display="flex" alignItems="center" className={classes.restDays}>
          {!isSupplier && (
            <Typography className={classes.number}>{endDate}</Typography>
          )}
          <Box ml={1}>
            <Typography>{textSecondary}</Typography>
          </Box>
        </Box>
        <Box className={classes.boxButton}>
          <Button
            type="button"
            variant="outlined"
            className={classes.button}
            onClick={handleRedirect}
            fullWidth
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
      {rdMarketing && (
        <BaseConfirmationDialog
          displayedButtons={false}
          title="Solicitação de contratação da plataforma"
          text="Essa solicitação foi encaminhada à nossa equipe, e entraremos em contato para dar continuidade ao
                processo de contratação."
          open={rdMarketing}
          setOpen={setRdMarketing}
          variant="success"
          loading={loading}
        />
      )}
    </>
  )
}

export default DisplayStaticUseLimitationNotice
